import axios from 'axios';
import router from '@/router';
import store from '../index.js';

let controller = new AbortController();

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'http://localhost:8090/',
    headers: { 
        "Accept": "application/json",
        "Authorization" : 'Bearer '+ localStorage.getItem('token')
    }
});

instance.interceptors.response.use((response) => response, (error) => {
    if(!axios.isCancel(error) && error.response && (error.response.status==='401' || error.response.status===401) && (localStorage.getItem('isLoggedIn')===true || localStorage.getItem('isLoggedIn')==='true')){ 
        window.localStorage.clear()
        store.dispatch('auth/LogOut')
        localStorage.removeItem('vuex')    
        localStorage.removeItem('token')
        localStorage.removeItem('isLoggedIn')
        location.reload()  
        router.push('/login')   
    }
    throw error
});
// do not create abort signal for function that can be used/persist in any page of the website
const exemptedURL = ['timetracker', 'generate','export', 'download' ]
instance.interceptors.request.use((config) => {
    if (!exemptedURL.some(url => config.url.includes(url))) { 
        config.signal = controller.signal;
    } return config;
}, (error) => {
    return Promise.reject(error);
});

export function createCancelToken(){
    let cancelTokenSource = axios.CancelToken.source();
    return cancelTokenSource;
}
export function cancelRequest(cancelTokenSource){
    cancelTokenSource.cancel('Cancelled request')
}
export function createAbortController(){
     controller = new AbortController();
}
export {controller}
export default instance